// src/hooks/useClickOutside.js
import { useEffect } from "react";

const useClickOutside = (refs, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const isInside = refs.some(
        (ref) => ref.current && ref.current.contains(event.target)
      );
      if (isInside) return;
      handler();
    };

    document.addEventListener("mousedown", listener);
    // document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refs, handler]);
};

export default useClickOutside;